const steps = [
  {
    number: "01",
    title: "Site Survey & Needs Assessment",
    desc: "Our engineers visit your facility to measure spaces, understand workflow requirements, and assess infection control needs before any design begins.",
    icon: "ri-map-pin-2-line",
    image: "/images/design/floor-plan.webp",
  },
  {
    number: "02",
    title: "Custom Design & Approval",
    desc: "We produce detailed 2D/3D drawings of every unit. You review and approve each design before we cut a single sheet of steel.",
    icon: "ri-draft-line",
    image: "/images/design/3d-model.webp",
  },
  {
    number: "03",
    title: "Precision Fabrication",
    desc: "Every unit is hand-fabricated in our Nairobi workshop using SS304/SS316 stainless steel with TIG-welded joints, polished finishes, and quality checks at every stage.",
    icon: "ri-tools-line",
    image: "/images/welding/stainless.webp",
  },
  {
    number: "04",
    title: "Delivery, Installation & Handover",
    desc: "Our installation team delivers, fits, and commissions all equipment on-site. We train your staff on maintenance and provide full after-sales support.",
    icon: "ri-truck-line",
    image: "/images/hospital/nurse-station.webp",
  },
];

export default function HospitalProcess() {
  return (
    <section id="process" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-teal-600 text-xs font-bold uppercase tracking-widest">How It Works</span>
          <h2 className="text-gray-900 text-3xl md:text-4xl font-extrabold mt-3 uppercase tracking-tight">
            Our 4-Step Process
          </h2>
          <p className="text-gray-500 text-sm mt-4 leading-relaxed">
            From your first call to the day your equipment is in use — we manage every step so you can focus on patient care.
          </p>
        </div>

        {/* Steps */}
        <div className="space-y-16">
          {steps.map((step, i) => (
            <div
              key={step.number}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${i % 2 === 1 ? "lg:flex-row-reverse" : ""}`}
            >
              {/* Image — flip order on odd */}
              <div className={i % 2 === 1 ? "lg:order-2" : ""}>
                <img
                  src={step.image}
                  alt={step.title}
                  className="w-full h-[280px] object-cover object-top rounded-lg"
                />
              </div>

              {/* Text */}
              <div className={i % 2 === 1 ? "lg:order-1" : ""}>
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-600 rounded-lg flex-shrink-0">
                    <i className={`${step.icon} text-xl text-white`}></i>
                  </div>
                  <span className="text-teal-600 text-5xl font-extrabold opacity-20 leading-none">{step.number}</span>
                </div>
                <h3 className="text-gray-900 text-xl font-extrabold uppercase tracking-tight mb-3">
                  {step.title}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
